import React from "react";
import { useNavigate } from "react-router-dom";
import "./renthouse.css";
import {
  ArrowLeft,
  ArrowRight,
  Home,
  ShieldCheck,
  Plus,
  Search,
  KeyRound,
  CalendarDays,
} from "lucide-react";

function RentHouse() {
  const navigate = useNavigate();

  return (
    <div className="bs-page rent-choice-page">

      {/* =================================================
          TOP BAR
      ================================================= */}

      <div className="bs-topbar">

        <button
          className="bs-back-btn"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>

        <div className="bs-brand">
          <span className="bs-brand-dot" />
          CIVILINK
        </div>

      </div>


      {/* =================================================
          HERO
      ================================================= */}

      <section className="bs-hero bs-rent-hero">

        <div className="bs-hero-overlay" />

        <div className="bs-hero-content">

          <div className="bs-eyebrow">
            <KeyRound size={15} />
            RENTAL MARKETPLACE
          </div>

          <h1>
            Find a place
            <br />
            <span>to call home.</span>
          </h1>

          <p>
            Looking for a rental or ready to list your
            house? Choose how you'd like to continue.
          </p>

        </div>

      </section>


      {/* =================================================
          MAIN
      ================================================= */}

      <main className="bs-main">

        <div className="bs-heading">

          <div>

            <span className="bs-section-label">
              WHAT WOULD YOU LIKE TO DO?
            </span>

            <h2>
              Rent or To-Let a House
            </h2>

            <p>
              Choose an option to continue.
            </p>

          </div>

        </div>


        {/* =================================================
            OPTIONS
        ================================================= */}

        <div className="bs-options">

          {/* =================================================
              TO-LET
          ================================================= */}

          <button
            className="bs-card bs-rent-list-card"
            onClick={() =>
              navigate("/post-rent-house")
            }
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Plus size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR HOME OWNERS
              </span>

              <h3>
                To-Let a House
              </h3>

              <p>
                List your house for rent and connect
                with people looking for a home.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Post your rental
              </span>

              <ArrowRight size={16} />

            </div>

          </button>


          {/* =================================================
              RENT
          ================================================= */}

          <button
            className="bs-card bs-rent-find-card"
            onClick={() =>
              navigate("/rental-house")
            }
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Search size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR TENANTS
              </span>

              <h3>
                Rent a House
              </h3>

              <p>
                Explore available rental homes and
                find a place that fits your budget.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Explore rental homes
              </span>

              <ArrowRight size={16} />

            </div>

          </button>

        </div>


        {/* =================================================
            RENTAL INFORMATION
        ================================================= */}

        <div className="bs-info-strip">

          <div className="bs-info-item">

            <div className="bs-info-icon">
              <Home size={18} />
            </div>

            <div>

              <strong>
                Explore Rentals
              </strong>

              <span>
                Discover available rental homes
              </span>

            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <CalendarDays size={18} />
            </div>

            <div>

              <strong>
                Check Rental Terms
              </strong>

              <span>
                Understand rent and availability
              </span>

            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <ShieldCheck size={18} />
            </div>

            <div>

              <strong>
                Verify Before Paying
              </strong>

              <span>
                Inspect the property and verify details
              </span>

            </div>

          </div>

        </div>


        {/* =================================================
            DISCLAIMER
        ================================================= */}

        <div className="bs-disclaimer">

          <ShieldCheck size={18} />

          <p>
            Civilink is a property listing platform.
            Rental listings are provided by users and
            are not a legal verification or guarantee
            by Civilink. Always visit the property,
            verify the owner and carefully review the
            rental agreement before making payments.
          </p>

        </div>

      </main>

    </div>
  );
}

export default RentHouse;